import React, { Component } from 'react'
import { Row, Col, Table, Icon, Popconfirm } from 'antd'
import IssueUploadA from './IssueUploadA'

import Permissions from '../models/Permissions'

class SimpleIssueStep3 extends Component {

    render() {
        const columns = [
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            key: 'descricao',
            render: (text, r) => (
                <span>
                    {r.descricao}
                </span>
            )
        },
        {
            title: 'Data',
            dataIndex: 'data_referencia',
            key: 'data_referencia',
            render: (text, r) => (
                <span>
                    {r.data_referencia}
                </span>
            )
        },
        {
            title: 'Opções',
            key: 'action',
            render: (text, record) => (
                <span>
                    { !Permissions.isDenied('issues', 'update') ? (
                        <Popconfirm title="DESTRUIR? Não poderá voltar atrás."
                            onConfirm={(e) => this.props.onRemoveAttach(record)}
                            okText="Sim" cancelText="Não">
                            <a role="button">
                                <Icon type="delete" style={{color: 'red'}} />
                            </a>
                        </Popconfirm>
                    ) : '' }
                </span>
            )
        }]
        this.props.attachments.map((item) => {
            item.key = item.id
            return item
        })
        return (
            <div className={this.props.className}>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Adicionar Fotografias</legend></Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6 hide-small">
                        <label htmlFor="issuedetection" className="ant-form-item" title="Anexos">
                            Fotografias
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14 issue-tree-wrapper">
                        <ol>
                            <li>
                                <IssueUploadA {...this.props} />
                            </li>
                        </ol>
                    </div>
                </div>

                { this.props.id ? (
                    <div id="attachments">
                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>Fotografias Previamente Adicionadas</legend>
                                <Table dataSource={this.props.attachments} columns={columns} />
                            </Col>
                        </Row>
                    </div>
                ) : ''}

            </div>
        )
    }
}

export default SimpleIssueStep3;



// WEBPACK FOOTER //
// ./src/components/SimpleIssueStep3.js